// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/global.css'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/common/flex.css'
import http from 'ctrlbox'
// 多语言
// import { installI18n } from 'ctrlbox'
// installI18n(Vue)
import i18n from '@/utils/languages'

import store from '@/store/index'
import './assets/css/public.css'
import { Loading } from 'element-ui'
import uploader from 'vue-simple-uploader'
import { regionData } from 'element-china-area-data'

import WechatAuth from '@/wechart-auth'

import videoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import * as dd from 'dingtalk-jsapi'
import { getDingApplicationLogin, getThirdConfig, getFeiApplicationLogin } from "@/service/getData"

Vue.use(videoPlayer)
Vue.use(Viewer)
Vue.use(uploader)


if (process.env.NODE_ENV === 'development') {
  require('@/service/mock')
}
//  判断内外网 链接
(function () {
  let jumplink = {}
  // 外网
  if (process.env.OUT_LINE == 'outline') {
    jumplink = {
      pm_main: 'http://projectadmin.ctrlbox.cn/#/projectManage/pm_main',
      user: 'http://projectadmin.ctrlbox.cn/#/projectManage/user',
      signout: 'http://authcenter.ctrlbox.cn',
      filecenter: 'http://filecenter.ctrlbox.cn/', // 文件中心基础地址
      project: 'http://project.ctrlbox.cn',
      doc: 'http://doc.ctrlbox.cn',
      site: 'http://site.ctrlbox.cn',
      relativeAddrStartIndex: 29// 相对地址截取索引
    }
  } else if (process.env.OUT_LINE == 'test') {
    jumplink = {
      pm_main: 'http://test.projectadmin.ctrlbox.cn/#/projectManage/pm_main',
      user: 'http://test.projectadmin.ctrlbox.cn/#/projectManage/user',
      signout: 'http://test.authcenter.ctrlbox.cn',
      filecenter: 'http://test.filecenter.ctrlbox.cn/',
      project: 'http://test.project.ctrlbox.cn',
      doc: 'http://test.doc.ctrlbox.cn',
      site: 'http://test.site.ctrlbox.cn',
      relativeAddrStartIndex: 34
    }
  } else if (process.env.OUT_LINE == 'fangda') {
    jumplink = {
      dm_main: 'http://docadmin.tontsenkm.com/#/docManage/dm_main',
      user: 'http://docadmin.tontsenkm.com/#/docManage/user',
      signout: 'http://authcenter.tontsenkm.com/api/auth/logout',
      // project: 'http://project.ctrlbox.cn',
      project: '#',
      doc: 'http://doc.tontsenkm.com',
      site: 'http://site.tontsenkm.com',
      filecenter: 'http://filecenter.tontsenkm.com/', // 文件中心基础地址
      relativeAddrStartIndex: 30// 相对地址截取索引
    }
  } else { // 内网
    jumplink = {
      dm_main: 'http://docadmin.glanway.org:8080/#/docManage/dm_main',
      user: 'http://docadmin.glanway.org:8080/#/docManage/user',
      signout: 'http://authcenter.glanway.org:8080/api/auth/logout',
      project: 'http://project.glanway.org:8080',
      doc: 'http://doc.glanway.org:8080',
      site: 'http://site.glanway.org:8080',
      filecenter: 'http://filecenter.glanway.org:8080/',
      relativeAddrStartIndex: 35
    }
  }

  Vue.prototype.jumplink = jumplink
})()
router.beforeEach((to, from, next) => {
  // 2024-04-15  对判断跳转重定向进行赋值，host有乱码，先用origin
  if (location.href.indexOf('/#/') == -1 && to.path == '/layout/sign/signin') {
    let href = location.host
    if (location.origin) {
      href = location.origin + '/' + location.hash
    }
    location.href = href
  }
  if (to.query && to.query.ownerId && to.name == 'account') {
    next({
      path: '/owner/personal',
      query: to.query
    })
  }
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '个人中心'
  }
  if (to.query && to.query.corpId) {
    // 钉钉应用登录
    if (dd.env.platform !== 'notInDingTalk') {
      dd.ready(() => {
        dd.runtime.permission.requestAuthCode({
          corpId: to.query.corpId,
          // 企业id  
          onSuccess: info => {
            let code = info.code
            getDingApplicationLogin({ code, appKey: to.query.appKey, appSecret: to.query.appSecret }).then(res => {
              if (res.data) {
                window.location.href = res.data
              }
            })
          },
          onFail: err => {
            console.log(err)
          }
          // 通过该免登授权码可以获取用户身份 
        })
      })
    }
  } else if (window.h5sdk) {
    if (to.query.appKey && to.query.appSecret) {
      // 飞书应用登录
      getThirdConfig().then(re => {
        if (re.data) {
          let feiAppKey = re.data.feiAppKey || ''
          tt.requestAuthCode({
            appId: feiAppKey,
            // 获取成功后的回调
            success (res) {
              console.log("getAuthCode succeed")
              //authorization code 存储在 res.code
              // 此处通过 fetch 把 code 传递给接入方服务端 Route: callback，并获得user_info
              // 服务端 Route: callback 的具体内容请参阅服务端模块 server.py 的callback() 函数
              // fetch(`/callback?code=${res.code}`).then(response2 => response2.json().then(res2 => {
              //   console.log("getUserInfo succeed");
              //   // 示例 Demo 中单独定义的函数 showUser，用于将用户信息展示在前端页面上
              //   showUser(res2);}
              //   )
              // ).catch(function (e) {console.error(e)})
              getFeiApplicationLogin({ code: res.code, appKey: to.query.appKey, appSecret: to.query.appSecret }).then(rew => {
                if (rew.data) {
                  window.location.href = rew.data
                }
              }).catch(err => next())
            },
            // 获取失败后的回调
            fail (err) {
              console.log(`getAuthCode failed, err:`, JSON.stringify(err))
            }
          })
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})


// 微信授权拦截处理
// Vue.use(WechatAuth, {
//     router,
//     appid: 'wxe4b3b956542bdc96',
//     responseType: 'code',
//     scope: 'snsapi_userinfo',
//     getCodeCallback (code, next) {
//         var ua = navigator.userAgent.toLowerCase()
//         console.log('设备:' + ua)
//         if (!(ua.match(/MicroMessenger/i) != 'micromessenger' && to.name.indexOf('notwechatbrowse'))) {
//             console.log('微信code:' + code)
//             getAccessToken({code}).then((res) => {
//                 let data = res.data
//                 console.log('callback---', data)
//                 if (data && data.openId) {
//                     next(data.openId)
//                 }
//             })
//         }else{
//             console.log('不是微信浏览器')
//         }
//     }
// })

Vue.prototype.$http = http
Vue.config.productionTip = false
// 强制重置语言
// let languagesSet = localStorage.getItem('languagesSet') || 'zh'
// if (languagesSet != 'zh') {
//   const langModule = require(`element-ui/lib/locale/lang/${languagesSet}`)
//   ElementUI.locale(langModule.default)
// }
Vue.use(ElementUI)
Vue.prototype.Loading = Loading
Vue.prototype.ctrlboxDev = process.env.NODE_ENV
/* eslint-disable no-new */
setTimeout(() => {
  new Vue({
    i18n,
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
}, 700)



// WEBPACK FOOTER //
// ./src/main.js